'use client';

import { Button } from '@/components/common/Button/Button';
import { useAppNavigationDialog } from '@/components/features/AppNavigationDialog/useAppNavigationDialog';
import { makeWorkplaceDetailDeeplink } from '@/utils/deeplink';
import { useTranslations } from 'next-intl';
import { JobSummaryFragment } from '../gen/graphql/JobRoute.generated';

export function JobApplyButton({ job }: { job: JobSummaryFragment }) {
  const t = useTranslations();
  const { navigate, Dialog } = useAppNavigationDialog({
    href: makeWorkplaceDetailDeeplink(job.workplace.id),
  });

  const handleClick = () => {
    navigate();
  };

  return (
    <>
      <Button className="w-full" size="large" onClick={handleClick}>
        {t('job.apply')}
      </Button>
      {Dialog}
    </>
  );
}
